module.exports = __webpack_public_path__ + "img/p022.3bbecece.png";